(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/View', 'templates', 'app/widget/screen-size/screenSizeView'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var templates = {
      mainNavTemplate: require('./mainNavTemplate.hbs')
    };
    module.exports = factory(require('backbone-torso/modules/View'), templates,
                             require('./../screen-size/screenSizeView'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoView, templates, screenSizeView) {
  'use strict';

  /**
   * Widget to display the main nav. Actual navigation items must be
   * added via extending this class. See design/design-nav for an
   * example.
   *
   * @class MainNavView
   * @extends Torso.View
   * @constructor
   */

  var MainNavView = TorsoView.extend({
    tagName: 'header',
    template: templates.mainNavTemplate,

    events: {
      'click [data-main-nav-dropdown]': '_openMainNavDropdown',
      'click [data-toggle-main-nav-drawer]': '_toggleMainNavDrawer'
    },

    /**
     * Set active dropdown id
     * @method _setActiveDropdownId
     * @private
     */
    _setActiveDropdownId: function(activeDropdownId) {
      this.set('activeMainNavDropdown', activeDropdownId);
    },

    /**
     * Get active dropdown id for comparison
     * @method _getActiveDropdownId
     * @private
     */
    _getActiveDropdownId: function() {
      return this.get('activeMainNavDropdown');
    },

    /**
     * Open a main nav dropdown menu
     * @method _openMainNavDropdown
     * @param event {object} passed click event
     * @private
     */
    _openMainNavDropdown: function(event) {
      var thisMenuId = event.target.getAttribute('aria-owns');

      // If this menu is already open
      if (this._getActiveDropdownId() === thisMenuId) {
        this.closeMainNavDropdown();
      } else {
        this._setActiveDropdownId(thisMenuId);
      }

      return false;
    },

    /**
     * Close a main nav dropdown menu
     * @method closeMainNavDropdown
     */
    closeMainNavDropdown: function() {
      this.set('activeMainNavDropdown', '');
    },

    /**
     * @method setCurrentNavItem
     * @param currentNavItem {String} set the active nav item based on the navItems
     * array
     */
    setCurrentNavItem: function(currentNavItem) {
      this.set('currentNavItem', currentNavItem);
    },

    /**
     * @method setCurrentDropdownItemParent
     * @param currentDropdownItemParent {string} of the moduleSpace of the current perspective identifying the current dropdown item's parent item
     */
    setCurrentDropdownItemParent: function(currentDropdownItemParent) {
      this.set('currentDropdownItemParent', currentDropdownItemParent);
    },

    /**
     * Toggle main nav drawer
     * @method _toggleMainNavDrawer
     * @private
     */
    _toggleMainNavDrawer: function() {
      if (this.get('mainNavDrawerOpen')) {
        this.closeMainNavDrawer();
      } else {
        this._openMainNavDrawer();
      }
      return false;
    },

    /**
     * Open main nav drawer
     * @method _openMainNavDrawer
     * @private
     */
    _openMainNavDrawer: function() {
      this.set('mainNavDrawerOpen', true);
      this._setActiveDropdownId('main-nav');
    },

    /**
     * Close main nav drawer
     * @method closeMainNavDrawer
     */
    closeMainNavDrawer: function() {
      if (!this.get('isLargeScreen')) {
        this.set('mainNavDrawerOpen', false);
      }
      this.closeMainNavDropdown();
    },

    /**
     * Detect whether it is in default screen view
     * @method _updateScreenSize
     * @private
     */
    _updateScreenSize: function() {
      var currentScreenIsLargerThanMobile = screenSizeView.currentSizeIsLarger(screenSizeView.SCREEN_SIZES.SMALL);
      this.set('isLargeScreen', currentScreenIsLargerThanMobile);
      this.set('mainNavDrawerOpen', currentScreenIsLargerThanMobile);
    },

    /**
     * @method initialize
     * @override
     */
    initialize: function() {
      this.set({
        activeMainNavDropdown: '',
        mainNavDrawerOpen: false,
        navItems: this.navItems,
        secondaryNavItems: this.secondaryNavItems
      });

      this.listenTo(this.viewState, 'change:currentNavItem change:showMainNavDropdown change:activeMainNavDropdown change:currentDropdownItemParent change:mainNavDrawerOpen change:isLargeScreen', this.render);
      this.listenTo(screenSizeView, 'change:screenSize', this._updateScreenSize);
      this._updateScreenSize();
    },

    /**
     * @method attachTrackedViews
     * @override
     */
    attachTrackedViews: function() {
      if (this.pageHeaderView) {
        this.attachView('page-header', this.pageHeaderView, { shared: true });
      }
      if (this.subHeaderView) {
        this.attachView('sub-header', this.subHeaderView, { shared: true });
      }
    },

    /**
     * @method prepare
     * @override
     */
    prepare: function() {
      var templateContext = TorsoView.prototype.prepare.apply(this);
      var hasPageHeader = this.pageHeaderView;
      var hasSubHeader = this.subHeaderView;
      var isLargeScreen = this.get('isLargeScreen');
      var showSubHeader = hasSubHeader && isLargeScreen;
      templateContext.showSubHeader = showSubHeader;
      templateContext.showPageHeader = hasPageHeader && !showSubHeader;
      return templateContext;
    }
  });

  return MainNavView;
}));
